import './webchat_history_message.js.coffee'
Namespace 'Customer.Webchat'

class Customer.Webchat.WebchatHistory extends Backbone.Collection
  model: Customer.Webchat.WebchatHistoryMessage
